import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { messages as portugueseMessages } from './languages/pt';

// pt é o fallback e fica no bundle; en/es são carregados sob demanda abaixo.
const lazyLanguages = {
  en: () => import('./languages/en'),
  es: () => import('./languages/es'),
};

// Só usa idioma salvo pelo usuário (localStorage). Sem cookie para não contribuir com tamanho de header.
// O front não grava cookies; config do backend fica em localStorage/memória.
i18n.use(LanguageDetector).init({
  debug: false,
  defaultNS: ['translations'],
  fallbackLng: 'pt',
  lng: 'pt',
  ns: ['translations'],
  resources: { ...portugueseMessages },
  detection: {
    order: ['localStorage'],
    caches: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
  },
});

// Carrega o idioma salvo (en/es) sem incluir os bundles não usados no carregamento inicial.
try {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
  const lang = stored ? stored.split('-')[0] : null;
  if (lang && lazyLanguages[lang]) {
    lazyLanguages[lang]()
      .then(({ messages }) => {
        const bundle = messages?.[lang]?.translations;
        if (bundle) {
          i18n.addResourceBundle(lang, 'translations', bundle, true, true);
          i18n.changeLanguage(stored);
        }
      })
      .catch(() => {
        /* mantém pt como fallback */
      });
  }
} catch (_) {
  /* localStorage indisponível — mantém pt */
}

export { i18n };
